import { render, staticRenderFns } from "./MultipleChoiceQuestion.vue?vue&type=template&id=836b35d6&scoped=true&"
import script from "./MultipleChoiceQuestion.vue?vue&type=script&lang=ts&"
export * from "./MultipleChoiceQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836b35d6",
  null
  
)

export default component.exports